module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"mainTitle":"Partners","subTitle":"They trust us"},"fr":{"mainTitle":"Partenaires","subTitle":"Ils nous font confiance"}}')
  delete Component.options._Ctor
}
